// src/utils/getEffectStyles.js

// EFEITOS VISUAIS DO HEADER (INLINE SAFE)
const getEffectStyles = (effect, neonColor = "#ff00ff") => {
  const color = /^#([0-9A-F]{3}){1,2}$/i.test(neonColor)
    ? neonColor
    : "#ff00ff";

  switch (effect) {
    case "neon":
      return {
        boxShadow: `
          0 0 10px ${color},
          0 0 20px ${color},
          0 0 40px ${color}
        `,
        borderBottom: `1px solid ${color}`,
      };

    case "rain":
      return {
        backgroundImage: `
          linear-gradient(rgba(255,255,255,.05) 1px, transparent 1px),
          linear-gradient(90deg, rgba(255,255,255,.05) 1px, transparent 1px)
        `,
        backgroundSize: "4px 4px",
        backdropFilter: "blur(2px)",
      };

    case "stars":
      return {
        backgroundImage: `
          radial-gradient(circle, rgba(255,255,255,.8) 1px, transparent 1px),
          radial-gradient(circle, rgba(255,255,255,.4) 1px, transparent 1px)
        `,
        backgroundSize: "24px 24px, 48px 48px",
        backgroundPosition: "0 0, 12px 12px",
      };

    case "glass":
      return {
        backdropFilter: "blur(10px)",
        backgroundColor: "rgba(255,255,255,.08)",
      };

    case "dots":
      return {
        backgroundImage: `radial-gradient(${color} 1px, transparent 1px)`,
        backgroundSize: "10px 10px",
      };

    case "wave":
      return {
        backgroundImage: `
          repeating-linear-gradient(
            45deg,
            ${color} 0%,
            transparent 10%
          )
        `,
        backgroundSize: "20px 20px",
      };

    default:
      return {};
  }
};

export default getEffectStyles;
